import useApi from './useApi';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { state, postApiData } = useApi();

    const checkPingTime = async (imoNumber: string, sentTimestampUtc: number, latency: number, offlineSinceDateTime?: number | null) => {
        const queryParams = { imoNumber, sentTimestampUtc, latency } as any;
        if (offlineSinceDateTime) {
            queryParams.offlineSinceDateTimeUtc = offlineSinceDateTime;
        }

        const result = await postApiData({
            endpoint: apiEndpoints['checkPingTime'].url,
            queryParam: buildQueryParams(queryParams),
            callInBackground: true,
            shouldReturnError: true,
            returnFullResponseObject: true,
            config: {
                timeout: 30000,
            },
        });

        return result;
    };

    return { state, checkPingTime };
};
